import React from "react";
import { FaClock } from "react-icons/fa";
import { SettingsSubgroupHeader } from "./SettingsSectionShell";
import SettingsFieldCard from "./SettingsFieldCard";
import valuesEqual from "./hooks/valuesEqual";

const COLOR = "amber";

/**
 * Tarih ve Saat — artık kendi sekmesi yok, "Görüntü ve Saat" bölümünün alt
 * grubu olarak AppearanceSection içinde render edilir. Başlık makinedeki menü
 * adıyla aynıdır (DateAndTimeSetting). Yazma grubu değişmedi:
 * `profile.timeDate`.
 */
export default function TimeDateSection({
  data,
  onChange,
  originalData,
  showHeader = true,
}) {
  if (!data || Object.keys(data).length === 0) return null;
  const keys = Object.keys(data);
  return (
    <div>
      {showHeader && (
        <SettingsSubgroupHeader
          icon={FaClock}
          title="Tarih ve Saat"
          count={keys.length}
          color={COLOR}
        />
      )}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3">
        {keys.map((k) => {
          const setting = data[k];
          const orig = originalData?.[k]?.value;
          const isChanged =
            orig !== undefined && !valuesEqual(setting.value, orig);
          return (
            <SettingsFieldCard
              key={k}
              setting={setting}
              onChange={(value) =>
                onChange({ group: "profile.timeDate", key: k, value })
              }
              isChanged={isChanged}
              originalValue={orig}
              color={COLOR}
            />
          );
        })}
      </div>
    </div>
  );
}
